/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const AvatarPlusBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 0c1.117 0 2.18.229 3.146.642-.28.22-.52.49-.707.795a7 7 0 104.124 4.123c.305-.185.575-.425.795-.705A8 8 0 118 0zm0 9.5c1.21 0 2.293.413 3.232 1.096.56.407.953.817 1.168 1.104a.5.5 0 01-.8.6 3.29 3.29 0 00-.234-.267 5.406 5.406 0 00-.722-.629C9.864 10.837 8.979 10.5 8 10.5c-.979 0-1.865.337-2.644.904-.275.2-.517.415-.722.63a3.29 3.29 0 00-.234.266.5.5 0 01-.8-.6c.215-.287.607-.697 1.168-1.104C5.707 9.913 6.79 9.5 8 9.5zm0-6a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM13.004 1a.5.5 0 01.5.5v1h.996a.5.5 0 010 1h-.996v1a.5.5 0 01-1 0v-1H11.5a.5.5 0 010-1h1.004v-1a.5.5 0 01.5-.5z"
        />
    </AccessibleSVG>
);

export default AvatarPlusBadge16;
